import { create } from "zustand";

const defaultAccountLevel = 1;

export const useConfiguratorStore = create((set) => ({
  accountLevel: defaultAccountLevel,
  unlockedTrophies: [],
  unlockedAchievements: [],
  unlockedAssets: [],
  completedBlocks: [],

  setAccountLevel: (level) => set({ accountLevel: level }),

  setUnlockedTrophies: (items) => set({ unlockedTrophies: items }),
  clearUnlockedTrophies: () => set({ unlockedTrophies: [] }),

  setUnlockedAchievements: (items) => set({ unlockedAchievements: items }),
  clearUnlockedAchievements: () => set({ unlockedAchievements: [] }),

  setUnlockedAssets: (items) => set({ unlockedAssets: items }),
  clearUnlockedAssets: () => set({ unlockedAssets: [] }),

  setCompletedBlocks: (items) => set({ completedBlocks: items }),

  addUnlockedTrophy: (trophyId) =>
    set((state) => ({
      unlockedTrophies: state.unlockedTrophies.includes(trophyId)
        ? state.unlockedTrophies
        : [...state.unlockedTrophies, trophyId],
    })),
}));
